export default {
  keben: '课本',
  course_1: '数学辅导书',
  course_2: '语文辅导书',
  course_3: '英语辅导书',
  course_4: '合订版',
  course_5: '物理辅导书',
  course_6: '化学辅导书',
  course_7: '生物辅导书',
  course_8: '政治辅导书',
  course_9: '历史辅导书',
  course_10: '地理辅导书',
  course_14: '道德与法治',
  '1': 'workbook',
  '9': 'workbook',
  '10': 'listen',
  '11': 'reading',
  '12': 'knowledge'
}
